export function DateFormatter(date: Date) {
    var cstTime = date.toString().split('-')[1] + "/" + date.toString().split('-')[2].split('T')[0] + "/" + date.toString().split('-')[0] + " " + date.toString().split('-')[2].split('T')[1].split(':')[0] + ":" + date.toString().split('-')[2].split('T')[1].split(':')[1]
    return cstTime
}